module.exports = __webpack_public_path__ + "static/media/app-icon.5a117a53.svg";